import { createContext, Dispatch } from 'react'
import { FixedActions, FixedActionTypes } from './types'
import { IToast } from '@components/molecules/toast'


export interface FixedState {
    /** Time in milliseconds */
    transitionTime: number
    toast?: IToast
}

export const initState: FixedState = {
    transitionTime: 0,
    toast: undefined,
}

export function FixedReducer(state = initState, action: FixedActionTypes): FixedState {
    switch (action.type) {
        case FixedActions.SET_TOAST: return { ...state, toast: action.payload }
        default: return state
    }
}

export const FixedContext = createContext<{ localState: FixedState, localDispatch: Dispatch<FixedActionTypes> }>({
    localState: initState,
    localDispatch: () => undefined,
})